export default "__VITE_ASSET__C2wan5qf__"